import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBoolean } from "@ispb/react-hooks";
import { Fragment } from "react";
import Countdown from "react-countdown";
import { Else, If, Then, When } from "react-if";
import { maybe } from "shared/maybe";
import IconText from "../components/IconText";
import { SUCCESS_ICON, WARNING_ICON } from "../icons";
import { Ramda } from "../namespaces/Ramda";
export default function FormStatus(props) {
    const saved = useBoolean();
    const dirtySinceSubmitted = !Ramda.equals(props.form.lastSubmitValue, props.form.value);
    /*
    useEffect(() => {
        if (props.form.lastSubmitResult === undefined) {
            return
        }
        saved.set(props.form.lastSubmitResult)
    }, [
        props.form.lastSubmitResult
    ])*/
    return (_jsx(Fragment, { children: maybe(props.autoSubmit, autoSubmit => {
            return (_jsx("span", { children: maybe(autoSubmit.next, next => {
                    return (_jsxs(Fragment, { children: [" Autosaving in ", _jsx(Countdown, { date: next, renderer: props => props.seconds + "s" }), "..."] }));
                }, () => {
                    return (_jsxs(If, { condition: props.form.lastSubmitResult === true, children: [_jsx(Then, { children: _jsx("span", { children: _jsx(IconText, { ...SUCCESS_ICON, className: "text-success", children: "Your changes have been saved." }) }) }), _jsx(Else, { children: _jsx(When, { condition: autoSubmit.pending, children: _jsx("span", { children: _jsx(IconText, { ...WARNING_ICON, className: "text-warning", children: "You have unsaved changes." }) }) }) })] }));
                }) }));
        }) }));
}
